import React from 'react'
import { IconButton, Box, LinearProgress, Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons';
import { useRouter } from 'react-router5';
import blue from '@material-ui/core/colors/indigo';

export default function StatusBar({ title }) {
  const router = useRouter()

  return (
    <div style={{ paddingBottom: '4rem' }}>
      <div
        style={{
          display: 'flex',
          marginBottom: '1rem',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4rem',
          padding: '1rem',
          background: blue[600],
          color: 'white',
          boxSizing: 'border-box',
        }}
      >

        <Typography variant="subtitle1" style={{ fontWeight: 700, flexGrow: 1 }}>
          {title}
        </Typography>

        <IconButton
          style={{ flexGrow: 0, color: 'white' }}
          onClick={() => router.navigate('home')}
        >
          <Close fontSize="small" />
        </IconButton>
      </div>
    </div>
  )
}